/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Collapse,
  IconButton,
  ListItemIcon,
  withWidth
} from '@material-ui/core'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { makeStyles } from '@material-ui/core/styles'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import CompareIcon from '@material-ui/icons/Compare'
import ExpandMore from '@material-ui/icons/ExpandMore'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import ListAltIcon from '@material-ui/icons/ListAlt'
import PaymentIcon from '@material-ui/icons/Payment'
import SettingsIcon from '@material-ui/icons/Settings'
import ThreeDRotationIcon from '@material-ui/icons/ThreeDRotation'
import VisibilityIcon from '@material-ui/icons/Visibility'
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff'
import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { version } from '../../../package.json'
import { Config } from '../../config'
import { useEditMode } from '../../providers/EditMode'
import { useGlobalState } from '../../providers/GlobalState'
import { useInjuries } from '../../providers/InjurySimulation'
import { useSlider } from '../../providers/SliderSimulation'
import IolLib from '../IOL/IolLib'
import SlidersOptions from '../Lesion/SlidersOptions'
import SliderDiseasesSimulation from '../Lesion/SlidersOptionsLesions'
import Snellen from '../VisionSimulation/Snellen'

const useStyles = makeStyles(theme => ({
  drawerBtn: {
    position: 'absolute',
    left: 5,
    top: 15,
    fontSize: '1rem'
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    '& > *': {
      zIndex: 100,
      overflow: 'hidden'
    }
  },
  editMode: {
    '&.MuiDrawer-paper': {
      background:
        'linear-gradient(180deg, rgba(51, 51, 51, 0.2) 0%, #333333 100%), linear-gradient(197.24deg, #F2994A 0%, #bd661b 98.81%)'
    }
  },
  normalMode: {
    '&.MuiDrawer-paper': {
      background:
        'linear-gradient(180deg, rgba(51, 51, 51, 0.2) 0%, #333333 100%), linear-gradient(197.24deg, #46A4E0 0%, #246193 98.81%)'
    }
  },
  drawerOpen: {
    width: 260,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    marginLeft: 40,
    width: 0,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  toolBarLine: {
    width: '90%',
    margin: theme.spacing(1, 0),
    borderBottom: '1px solid rgba(189, 189, 189, 0.5)'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: theme.palette.primary.contrastText,
    padding: theme.spacing(1),
    ...theme.mixins.toolbar
  },
  toolBarOpen: {
    position: 'fixed',
    width: 260,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  toolBarClose: {
    width: 0,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  toolBarText: {},
  toolBarTextOpen: {
    opacity: 1,
    transition: theme.transitions.create('opacity', {
      delay: 200,
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  toolBarTextClose: {
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.primary.contrastText
  },
  editModeList: {
    marginTop: theme.spacing(14),
    '&::-webkit-scrollbar-thumb': {
      background: '#bd661b',
      borderRadius: theme.shape.borderRadius
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#bd661b'
    }
  },
  normalModeList: {
    marginTop: theme.spacing(10),
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.primary.main,
      borderRadius: theme.shape.borderRadius
    },
    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.primary.dark
    }
  },
  list: {
    padding: theme.spacing(1),
    maxHeight: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    /* width */
    '&::-webkit-scrollbar': {
      width: 12
    },
    /* Track */
    '&::-webkit-scrollbar-track': {
      background: 'transparent'
    }
  },
  preventScroll: {
    overflowY: 'hidden'
  },
  listColor: {
    color: theme.palette.primary.contrastText,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    flex: 'none',
    alignSelf: 'center',
    flexGrow: 0,
    margin: '10px 10px',
    borderRadius: 8
  },
  submenu: {
    flex: 'none',
    alignSelf: 'center',
    width: '100%',
    flexGrow: 0,
    borderRadius: 8,
    backgroundColor: 'rgba(189, 189, 189, 0.2)',
    height: '80vh'
  },
  submenuColor: {
    color: theme.palette.primary.contrastText,
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '16px',
    borderRadius: 8
  },
  submenuIcon: {
    color: theme.palette.primary.contrastText
  },
  selected: {
    '&.Mui-selected, &.Mui-selected:hover': {
      background: theme.palette.primary.main,
      position: 'sticky',
      top: -8,
      zIndex: 1000
    },
    letterSpacing: 0.3
  },
  submenuSelected: {
    '&.Mui-selected, &.Mui-selected:hover': {
      background: theme.palette.primary.light
    },
    letterSpacing: 0.3
  },
  submenuDisabled: {
    backgroundColor: '#f89c9c'
  },
  logo: {
    position: 'relative',
    height: 58,
    width: 160
  },
  submenuText: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  logoOpen: {
    opacity: 1,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  logoClose: {
    opacity: 0,
    transition: theme.transitions.create('opacity', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  version: {
    color: '#fff',
    fontSize: 12,
    textAlign: 'left',
    marginLeft: 5,
    position: 'absolute',
    bottom: 0,
    width: '100%'
  }
}))

interface SideBarProps {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

interface SubmenuItem {
  name: string
  path: string
  disabled?: boolean
}

interface ItemMenu {
  name: string
  path: string
  changeOpen: () => void
  open?: boolean
  submenu?: SubmenuItem[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subPaths?: any
}

const EditModeBanner = styled.div`
  /* padding: 16px; */
  width: 100%;
  border-radius: 8px;
  background: #f47c36;
  display: flex;
  flex-direction: column;
`

const Sidebar = ({ open, setOpen }: SideBarProps) => {
  const [optionsOpen, setOptionsOpen] = useState({
    type: false,
    lesion: false,
    iol: false,
    vision: false,
    lib: false
  })
  const location = useLocation()
  const classes = useStyles()
  const menuEl = useRef<HTMLUListElement>(null)
  const { forceUpdate } = useInjuries()
  const {
    handleChangeLeft,
    handleChangeRight,
    forceUpdate: forceUpdateSlider
  } = useSlider()
  const { iolTypes, iolLibraries, cataractTypes, anatomyEye } = useGlobalState()
  const { editMode, updateEditMode } = useEditMode()

  useEffect(() => {
    if (optionsOpen.lib) {
      setTimeout(() => {
        menuEl.current?.scrollTo({ top: 350, behavior: 'smooth' })
        console.log(menuEl.current?.scrollTop)
      }, 200)
    }
  }, [optionsOpen.lib])

  const diseases = [
    {
      name: 'Lesão central',
      id: 'dmri',
      min: 0,
      max: 100,
      step: 10,
      defaultValue: 0
    },
    // {
    //   name: 'Oclusões Vasculares',
    //   id: 'Oclusões Vasculares',
    //   min: 0,
    //   max: 100,
    //   step: 10,
    //   defaultValue: 0
    // },
    // {
    //   name: 'Toxoplasmose',
    //   id: 'toxoplasmose',
    //   min: 0,
    //   max: 100,
    //   step: 10,
    //   defaultValue: 0
    // },
    // {
    //   name: 'Buraco Macular',
    //   id: 'buraco',
    //   min: 0,
    //   max: 100,
    //   step: 10,
    //   defaultValue: 0
    // },
    {
      name: 'Lesão periférica',
      id: 'glaucoma',
      min: 0,
      max: 100,
      step: 10,
      defaultValue: 0
    }
    // {
    //   name: 'Descolamento de Retina Periférico',
    //   id: 'Descolamento de Retina Periférico',
    //   min: 0,
    //   max: 100,
    //   step: 10,
    //   defaultValue: 0
    // }
  ]

  const visionconfig = [
    {
      name: 'Amarelamento',
      id: 'sepia',
      min: 0,
      max: 100,
      step: 10,
      marks: true,
      defaultValue: 0
    },
    {
      name: 'Nebulosidade',
      id: 'opacity',
      min: 0,
      max: 100,
      step: 10,
      marks: true,
      defaultValue: 0
    },
    {
      name: 'Contraste',
      id: 'contrast',
      min: 0,
      max: 100,
      step: 10,
      marks: true,
      defaultValue: 0
    }
  ]

  const Diseases = () => (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <SlidersOptions diseases={diseases} />
    </div>
  )

  const VisionSimulation = () => (
    <div style={{ position: 'relative' }}>
      <div
        style={{
          display: 'flex',
          color: '#fff',
          backgroundColor: '#46A4E0'
        }}
      >
        <div
          style={{
            width: '50%',
            height: 26,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          Antes
        </div>
        <div
          style={{
            width: '50%',
            height: 26,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          Depois
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          height: '100%',
          top: 0,
          left: '50%',
          border: '1px solid rgba(000,000,000,0.2)'
        }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start'
        }}
      >
        <div style={{ marginTop: 20, marginBottom: 20, marginLeft: 10 }}>
          <Snellen name="blur" handleChange={handleChangeLeft} />
        </div>
        <div style={{ marginTop: 20, marginBottom: 20, marginRight: 60 }}>
          <Snellen name="blur" handleChange={handleChangeRight} />
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'relative'
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              width: '50%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
          >
            <SliderDiseasesSimulation
              diseases={visionconfig}
              handleChange={handleChangeLeft}
            />
          </div>
          <div
            style={{
              width: '50%',
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column'
            }}
          >
            <SliderDiseasesSimulation
              diseases={visionconfig}
              handleChange={handleChangeRight}
            />
          </div>
        </div>
      </div>
    </div>
  )

  const typeChange = () => {
    if (forceUpdate) {
      forceUpdate()
    }
    if (forceUpdateSlider) {
      forceUpdateSlider()
    }
    setOptionsOpen({
      type: !optionsOpen.type,
      iol: false,
      lesion: false,
      lib: false,
      vision: false
    })
  }
  const lesionChange = () => {
    if (forceUpdateSlider) {
      forceUpdateSlider()
    }
    setOptionsOpen({
      type: false,
      iol: false,
      lesion: !optionsOpen.lesion,
      lib: false,
      vision: false
    })
  }
  const iolChange = () => {
    if (forceUpdate) {
      forceUpdate()
    }
    if (forceUpdateSlider) {
      forceUpdateSlider()
    }
    setOptionsOpen({
      type: false,
      iol: !optionsOpen.iol,
      lesion: false,
      lib: false,
      vision: false
    })
  }
  const libChange = () => {
    if (forceUpdate) {
      forceUpdate()
    }
    if (forceUpdateSlider) {
      forceUpdateSlider()
    }
    setOptionsOpen({
      type: false,
      iol: false,
      lesion: false,
      lib: !optionsOpen.lib,
      vision: false
    })
  }
  const visionChange = () => {
    if (forceUpdate) {
      forceUpdate()
    }
    setOptionsOpen({
      type: false,
      iol: false,
      lesion: false,
      lib: false,
      vision: !optionsOpen.vision
    })
  }
  const closeAll = () => {
    if (forceUpdate) {
      forceUpdate()
    }
    if (forceUpdateSlider) {
      forceUpdateSlider()
    }
    setOptionsOpen({
      type: false,
      iol: false,
      lesion: false,
      lib: false,
      vision: false
    })
  }

  const getSubMenu = () => {
    const list: SubmenuItem[] = []
    cataractTypes?.forEach(type => {
      if (type && (type.enable || editMode)) {
        const data: SubmenuItem = {
          name: type.name,
          path: `/nav/catarata/${type.slug}`,
          disabled: !type.enable
        }
        list.push(data)
      }
    })
    return list
  }

  const navigation = [
    // {
    //   name: 'Pacientes',
    //   path: '/nav/pacientes',
    //   icon: PeopleIcon,
    //   changeOpen: closeAll
    // },
    {
      name: 'Tipo de Catarata',
      path: '/nav/catarata',
      open: optionsOpen.type,
      changeOpen: typeChange,
      icon: ListAltIcon,
      submenu: getSubMenu()
    },
    {
      name: 'Lesões na Retina',
      path: '/nav/lesao',
      open: optionsOpen.lesion,
      changeOpen: lesionChange,
      icon: VisibilityOffIcon,
      children: Diseases
    },
    {
      name: 'Simulação Visão',
      path: '/nav/visao',
      open: optionsOpen.vision,
      changeOpen: visionChange,
      icon: CompareIcon,
      children: VisionSimulation
    },
    {
      name: 'Tipos de IOL',
      path: '/nav/iol',
      open: optionsOpen.iol,
      changeOpen: iolChange,
      icon: LibraryBooksIcon,
      submenu: iolTypes
        ?.map(iol => {
          if (!iol) return undefined
          const data: SubmenuItem = {
            name: iol.name,
            path: `/nav/iol/${iol?.slug}`,
            disabled: !iol.enable
          }

          return data
        })
        .filter(iol => {
          if (!iol) return false
          if (editMode) return true
          if (iol.disabled) return false
          return true
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        }) as any
    },
    {
      name: 'Biblioteca de IOL',
      path: '/nav/biblioteca',
      open: optionsOpen.lib,
      changeOpen: libChange,
      icon: ThreeDRotationIcon,
      children: IolLib,
      subPaths: iolLibraries
    },
    ...(anatomyEye?.enable || editMode
      ? [
          {
            name: anatomyEye ? anatomyEye.name : '',
            path: '/nav/anatomia-olho',
            icon: VisibilityIcon,
            changeOpen: closeAll
          }
        ]
      : []),
    {
      name: 'Orçamento Cirúrgico',
      path: '/nav/orcamento',
      icon: PaymentIcon,
      changeOpen: closeAll
    },
    {
      name: 'Configurações',
      path: '/configuracao/conta',
      icon: SettingsIcon,
      changeOpen: closeAll
    }
  ]

  const variant = 'permanent'

  const handleLink = (item: ItemMenu) => {
    if (item.submenu) {
      return item.submenu[0]?.path
    } else if (item.children !== undefined) {
      return `${item.path}/${
        (item.subPaths && item.subPaths[0] && item.subPaths[0].slug) || '0'
      }`
    } else {
      return item.path
    }
  }

  return (
    <Drawer
      variant={variant}
      open={open}
      onClose={setOpen}
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
          [classes.editMode]: editMode,
          [classes.normalMode]: !editMode
        })
      }}
    >
      {/* logo */}
      <div
        className={clsx(classes.toolbar, {
          [classes.toolBarOpen]: open,
          [classes.toolBarClose]: !open
        })}
      >
        <IconButton
          aria-label="fechar menu"
          onClick={() => setOpen(!open)}
          color="inherit"
          className={classes.drawerBtn}
        >
          <ArrowBackIosIcon fontSize="small" />
        </IconButton>
        <img
          src={Config.logoMenu}
          alt="logo"
          className={clsx(classes.logo, {
            [classes.logoOpen]: open,
            [classes.logoClose]: !open
          })}
        />
        <div className={classes.toolBarLine} />
        {editMode && (
          <EditModeBanner>
            <Button onClick={() => updateEditMode(false)}>
              Desativar modo de edição
            </Button>
          </EditModeBanner>
        )}
      </div>
      <Divider />
      {/* lista */}
      <List
        className={clsx(classes.list, {
          [classes.preventScroll]:
            location.pathname.startsWith('/nav/biblioteca') && optionsOpen.lib,
          [classes.editModeList]: editMode,
          [classes.normalModeList]: !editMode
        })}
        ref={menuEl}
      >
        {navigation.map((item, index) => {
          if (item.name === '' || (item.submenu && !item.submenu.length)) {
            return ''
          }
          return (
            <React.Fragment key={index}>
              <ListItem
                button
                component={
                  location.pathname.startsWith(item.path) ? 'div' : Link
                }
                to={handleLink(item)}
                onClick={() => item.changeOpen()}
                selected={location.pathname.startsWith(item.path)}
                className={classes.listColor}
                classes={{
                  selected: classes.selected
                }}
              >
                {item.icon && (
                  <ListItemIcon
                    style={{
                      minWidth: 36
                    }}
                  >
                    <span className={classes.submenuIcon}>
                      <item.icon />
                    </span>
                  </ListItemIcon>
                )}
                <ListItemText
                  primary={item.name}
                  classes={{
                    primary: clsx({
                      [classes.selected]: location.pathname.startsWith(
                        item.path
                      )
                    })
                  }}
                />
                {(item.submenu || item.children !== undefined) &&
                  location.pathname.startsWith(item.path) && <ExpandMore />}
              </ListItem>
              {item.submenu && (
                <Collapse
                  in={item.open}
                  timeout="auto"
                  unmountOnExit
                  className={classes.submenu}
                >
                  {item.submenu.map((sub: any, index: number) => (
                    <ListItem
                      button
                      component={Link}
                      key={index}
                      to={sub.path}
                      selected={location.pathname === sub.path}
                      className={clsx({
                        [classes.submenuDisabled]: sub.disabled,
                        [classes.submenuColor]: !sub.disabled
                      })}
                      classes={{
                        selected: classes.submenuSelected
                      }}
                    >
                      <ListItemText
                        primary={sub.name}
                        classes={{
                          primary: clsx({
                            [classes.submenuSelected]:
                              location.pathname === sub.path,
                            [classes.submenuText]: true
                          })
                        }}
                      />
                    </ListItem>
                  ))}
                </Collapse>
              )}
              {item.children && (
                <Collapse
                  in={item.open}
                  timeout="auto"
                  unmountOnExit={!location.pathname.startsWith(item.path)}
                  className={classes.submenu}
                >
                  <div>{item.children()}</div>
                </Collapse>
              )}
            </React.Fragment>
          )
        })}
      </List>
      <span className={classes.version}>{version}</span>
    </Drawer>
  )
}

export default withWidth()(Sidebar)
